import React from 'react'
import Card from './Card'


function FillCard() {
  return (
  
    
    <div className="wrapper">
    <Card
      img="https://i.pinimg.com/564x/c5/cf/ad/c5cfad882052dc833330afac4ae7390f.jpg"
      title="Single Bed Room"
      description="This room is located on the top floor of the hotel and has hot / cold air conditioned, a furnished balcony with sun loungers with swimming pool or mountain views and free WI FI."
    />

    <Card
      img="https://i.pinimg.com/564x/e8/c5/0c/e8c50ce285b0a5730a23db4e1459cd3b.jpg"
      title="Double Bed Room"
      description="This completely renovated and soundproofed room, all exterior with furnished balcony and pool view, air conditioning hot / cold and free WI FI."
    />

    <Card
      img="https://i.pinimg.com/564x/56/09/bd/5609bd75d18e36354262f3763f324bea.jpg"
      title="Triple Bed Room"
      description="Furnished balcony with garden pool views, telephone, flat screen TV with satellite channels"
    />
  </div>

    
  )
}



export default FillCard

